var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSevenstarsPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 247 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#paint0_linear_4124_2163)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H247V388H0V0Z",
    fill: "url(#paint1_linear_4124_2163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 388H0V0H247V311.198L103 388Z",
    fill: "url(#paint2_linear_4124_2163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 388H0V0H247V139.64L103 388Z",
    fill: "url(#paint3_linear_4124_2163)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199 0L103 388H0V0H199Z",
    fill: "url(#paint4_linear_4124_2163)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0L103 388H0V0H47Z",
    fill: "url(#paint5_linear_4124_2163)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 229L103 388H0V229Z",
    fill: "url(#paint6_linear_4124_2163)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 312L103 388H0V312Z",
    fill: "url(#paint7_linear_4124_2163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4124_2163",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4124_2163",
    x1: 247,
    y1: 340.123,
    x2: 118.081,
    y2: 388.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#741323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#741121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4124_2163",
    x1: 247,
    y1: 212.452,
    x2: 107.441,
    y2: 388.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#680C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#851426"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4124_2163",
    x1: 118,
    y1: 0,
    x2: 118,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0293951,
    stopColor: "#7D1224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90152A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4124_2163",
    x1: 52,
    y1: 226.416,
    x2: 157,
    y2: 226.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#771022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B1528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4124_2163",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D182E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4124_2163",
    x1: 0,
    y1: 387,
    x2: 103,
    y2: 387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#881428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31E37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4124_2163",
    x1: 0,
    y1: 387.007,
    x2: 103,
    y2: 387.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevenstarsPattern);
export default __webpack_public_path__ + "static/media/sevenstars_pattern.636146682a4a4990178dfa01e26d0638.svg";
export { ForwardRef as ReactComponent };